import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form } from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function CenterAddBankAccountView({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [bankName, setBankName] = useState()

  useEffect(() => {
    if (schema?.bankName?.value) {
      handleOnChangeSelectPicker(schema.bankName.value)
    }
  }, [schema])

  const handleOnChangeSelectPicker = (value) => {
    const label = getValueFromOptions(schema.bankName?.options, value)
    setBankName(label)
  }

  return (
    <>
      <Form>
        <Panel>
          <Row>
            {schema.bankName && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                <p>
                  {schema.bankName.label} :{' '}
                  <strong>
                    {getValueFromOptions(schema.bankName?.options, schema?.bankName?.value) ||
                      '-ไม่ระบุ-'}
                  </strong>
                </p>
              </Col>
            )}

            {schema.bankBranch && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                <p>
                  {schema.bankBranch.label} :{' '}
                  {/* <strong>{schema.bankBranch.value || '-ไม่ระบุ-'}</strong> */}
                  <strong>
                    {getValueFromOptions(schema.bankBranch?.options, schema?.bankBranch?.value) ||
                      '-ไม่ระบุ-'}
                  </strong>
                </p>
              </Col>
            )}

            {schema.bankAccountType && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                <p>
                  {schema.bankAccountType.label} :{' '}
                  {/* <strong>{schema.bankAccountType.value || '-ไม่ระบุ-'}</strong> */}
                  <strong>
                    {getValueFromOptions(
                      schema.bankAccountType?.options,
                      schema?.bankAccountType?.value
                    ) || '-ไม่ระบุ-'}
                  </strong>
                </p>
              </Col>
            )}
          </Row>

          <Row>
            {schema.bankAccountNumber && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                <p>
                  {schema.bankAccountNumber.label} :{' '}
                  <strong>{schema.bankAccountNumber.value || '-ไม่ระบุ-'}</strong>
                </p>
              </Col>
            )}

            {schema.bankAccountName && (
              <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 10 }}>
                <p>
                  {schema.bankAccountName.label} :{' '}
                  <strong>{schema.bankAccountName.value || '-ไม่ระบุ-'}</strong>
                </p>
              </Col>
            )}
          </Row>
        </Panel>
      </Form>
    </>
  )
}
